import { apiGet } from './client';
import type { DashboardData } from '../types/Dashboard';

// Tenant-scoped home-page aggregate.
export function getDashboard(): Promise<DashboardData> {
  return apiGet<DashboardData>('/api/dashboard');
}
